import { BillingTypeSchema, CardSchema, FeaturesSummary, InternalStatusSchema, ProductCodeSchema, StripeSubscriptionStatusSchema, } from "@supernova-studio/model";
import { DTOBillingInterval, DTOWorkspaceRole } from "./enums";
import z from "zod";
export const DTOCreditBalance = z.object({
    paidTopUp: z
        .object({
        total: z.number(),
        used: z.number(),
        balance: z.number(),
    })
        .optional(),
    paidRecurring: z
        .object({
        total: z.number(),
        used: z.number(),
        balance: z.number(),
        resetAt: z.string().optional(),
    })
        .optional(),
    free: z
        .object({
        credits: z.object({
            total: z.number(),
            used: z.number(),
            balance: z.number(),
            resetAt: z.string().optional(),
        }),
        /**
         * @deprecated The free plan daily spending limit was removed,
         * - once successfully deployed to production, can be removed in follow up deployment
         */
        spendingLimit: z
            .object({
            total: z.number(),
            used: z.number(),
            balance: z.number(),
            resetAt: z.string().optional(),
        })
            .optional(),
    })
        .optional(),
});
export const DTOCreditsPrices = z.object({
    creditsToCentsConversionRate: z.number(),
    purchaseTopUpCreditsToCentsConversionRate: z.number(),
});
export const DTOSubscription = z.object({
    stripeSubscriptionId: z.string().optional(),
    stripeCustomerId: z.string().optional(),
    stripeScheduleId: z.string().optional(),
    status: InternalStatusSchema.optional(),
    subscriptionStatus: StripeSubscriptionStatusSchema.optional(),
    internalStatus: InternalStatusSchema.optional(),
    product: ProductCodeSchema,
    featuresSummary: FeaturesSummary.optional(),
    allowedRoles: DTOWorkspaceRole.array(),
    /**
     * @deprecated get available-products for this information
     */
    stripeProductDescription: z.string().optional(),
    /**
     * @deprecated get available-products for this information
     */
    stripeProductFeatures: z.array(z.string()).optional(),
    /**
     * @deprecated get available-products for this information
     */
    stripeProductAdditionalFeatures: z.array(z.string()).optional(),
    /**
     * @deprecated always undefined
     */
    stripeSubscriptionMainItemId: z.string().optional(),
    /**
     * @deprecated use `fullSeatPriceId` or `builderSeatPriceId`
     */
    planPriceId: z.string(),
    planInterval: DTOBillingInterval,
    /**
     * @deprecated All subscriptions were migrated to work as "price per creator"
     */
    isPricePerCreator: z.boolean().optional(),
    legacyVersion: z.string().optional(),
    seats: z.number(),
    seatLimit: z.number(),
    fullSeats: z.number(),
    fullSeatLimit: z.number(),
    builderSeats: z.number(),
    builderSeatLimit: z.number(),
    mcpConsumerLimit: z.number().optional(),
    additionalCredits: z.number(),
    currentPeriodStart: z.string().optional(),
    currentPeriodEnd: z.string().optional(),
    subscriptionStatusUpdatedAt: z.string().optional(),
    cancelAt: z.string().nullish(),
    card: CardSchema.optional(),
    // New
    amount: z.number(),
    isTrial: z.boolean(),
    billingType: BillingTypeSchema.optional(),
    daysUntilDue: z.number().optional(),
    fullSeatPriceId: z.string(),
    builderSeatPriceId: z.string().optional(),
    additionalCreditsPriceId: z.string().optional(),
});
export const DTOSubscriptionUpcomingChange = z.object({
    effectiveAt: z.string(),
    fullSeatLimit: z.number().optional(),
    builderSeatLimit: z.number().optional(),
    additionalCredits: z.number().optional(),
});
export const DTOSubscriptionResponse = z.object({
    subscription: DTOSubscription,
    subscriptionUpcomingChange: DTOSubscriptionUpcomingChange.optional(),
    creditBalance: DTOCreditBalance.optional(),
    creditsPrices: DTOCreditsPrices,
});
export const DTOSubscriptionUpdatePreview = z.object({
    proration: z.object({
        amount: z.number(),
    }),
    nextBillingCycle: z.object({
        amount: z.number(),
    }),
});
export const DTOSubscriptionUpdatePreviewResponse = z.object({
    preview: DTOSubscriptionUpdatePreview,
});
//
// Inputs
//
export const DTOSubscriptionUpdateInput = z.object({
    additionalCredits: z.number(),
    builderSeats: z.number(),
    fullSeats: z.number(),
});
